import { request } from '@/shared/api/request'

export const safetyDoc = (externalId) => {
	return request({ url: `safety/free/safetyDoc/${externalId}?type=ACTN1`, method: 'GET' })
}
